module.exports = __webpack_public_path__ + "img/2.2.3ce8e9e1.png";